import './index.css';
import React from 'react'

import { Button } from './components/ui/button'
import { Skeleton } from './components/ui/skeleton'

import { RefreshCwIcon } from 'lucide-react'

type SummaryProps = {
	getSummaryQuery: any
	createSummaryMutation: any
    quickMessages: any[]
    loading: boolean
}

class Summary extends React.Component<SummaryProps>{
    render(){

        const{getSummaryQuery, createSummaryMutation, quickMessages, loading} = this.props

        if (getSummaryQuery.isLoading || createSummaryMutation.isLoading || loading) {
            return (
                <div className="flex h-full flex-col justify-between p-6">
                    <div className="flex flex-col space-y-6">
                        <div className="space-y-4">
                            <Skeleton className="h-8" />
                            <Skeleton className="h-40" />
                        </div>
                        <div className="space-y-4">
                            <Skeleton className="h-8" />
                            <Skeleton className="h-40" />
                        </div>
                        <div className="space-y-4">
                            <Skeleton className="h-8" />
                            <Skeleton className="h-40" />
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="flex flex-col space-y-6 p-6">
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        Column Descriptions
                    </h4>
                    <ul className="ml-6 mt-6 list-disc [&>li]:mt-2">
                        {Object.entries(
                            getSummaryQuery.data?.summary?.columnsDescriptions || {}
                        ).map(([key, value]) => (
                            <li key={key}>
                                {key}: {value as React.ReactNode}
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        General Statistics
                    </h4>
                    <p className="leading-7 [&:not(:first-child)]:mt-6">
                        {getSummaryQuery.data?.summary?.generalStatistics}
                    </p>
                </div>
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        General Analysis
                    </h4>
                    <p className="leading-7 [&:not(:first-child)]:mt-6">
                        {getSummaryQuery.data?.summary?.generalAnalysis}
                    </p>
                </div>
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        Questions
                    </h4>
                    <ul className="ml-6 mt-6 list-disc [&>li]:mt-2">
                        {quickMessages.slice(0,3).map(question => (
                            <li key={question}>{question}</li>
                        ))}

                    </ul>
                </div>
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        Opportunities
                    </h4>
                    <p className="leading-7 [&:not(:first-child)]:mt-6">
                        {getSummaryQuery.data?.summary?.opportunities}
                    </p>
                </div>
                <div>
                    <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">
                        Data Contents
                    </h4>
                    <p className="leading-7 [&:not(:first-child)]:mt-6">
                        {getSummaryQuery.data?.summary?.dataContents}
                    </p>
                </div>
                <Button onClick={() => createSummaryMutation.mutate()}>
                    <RefreshCwIcon className="mr-2 h-4 w-4" /> Re-analyze
                </Button>
            </div>
        ) 
    }
}

export { Summary }